import { BRAND } from "../../utils/constants/colors";

export function TourArrow({ base, placement, size }) {
  const isTop = placement?.startsWith("top");
  const isBottom = placement?.startsWith("bottom");
  const isLeft = placement?.startsWith("left");
  const isRight = placement?.startsWith("right");

  let clipPath = "polygon(50% 0%, 0% 100%, 100% 100%)";
  if (isTop) clipPath = "polygon(0% 0%, 100% 0%, 50% 100%)";
  if (isRight) clipPath = "polygon(100% 0%, 0% 50%, 100% 100%)";
  if (isLeft) clipPath = "polygon(0% 0%, 100% 50%, 0% 100%)";

  const vertical = isTop || isBottom;
  return (
    <div
      style={{
        width: vertical ? base : size,
        height: vertical ? size : base,
        background: BRAND.PRIMARY,
        clipPath,
        filter: "drop-shadow(0 2px 6px rgba(255,72,72,0.5))",
      }}
    />
  );
}
